import React from 'react';
import {render} from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import {Router, RouterContext, match} from 'react-router';
import {createHistory, createMemoryHistory} from 'history';

import Html from './launch_html';
import routes from './launch_routes';

// Client render (optional):
if(typeof document !== 'undefined'){
    const history = createHistory();
    const root = document.getElementById('root');

    function logPageView(){
        // Google Tag Manager:
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-TZJ3J5B');
    }

    render(
        <Router
            history={history}
            routes={routes}
            onUpdate={logPageView} />,
        root
    );
}

// Exported static site renderer:
export default (locals, callback) => {
    const history = createMemoryHistory();
    const location = history.createLocation(locals.path);

    function matchLocation(location) {
        match({routes, location}, (error, redirectionLocation, renderProps) => {
            if (redirectionLocation) {
                return matchLocation(redirectionLocation);
            }

            const content = ReactDOMServer.renderToString(
                <RouterContext {...renderProps} />
            );

            const fullPageHtml = ReactDOMServer.renderToStaticMarkup(
                <Html {...locals} content={content} />
            );

            callback(null, fullPageHtml);
        });
    }

    matchLocation(location);
};



// WEBPACK FOOTER //
// ./web/js/launch_index.js